import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GetAllChecklistsUseCase, GetChecklistsStateUseCase } from '@features/investigation-types';

export const getInvestigationTypeChecklistsResolver: ResolveFn<void> = () => {
  const _getAllChecklistsUseCase = inject(GetAllChecklistsUseCase);
  const _getChecklistsStateUseCase = inject(GetChecklistsStateUseCase);

  const state = _getChecklistsStateUseCase.execute();
  if (!state.hasChecklists()) {
    _getAllChecklistsUseCase.execute().subscribe();
  }
};
